import BasicChart from "./basic-chart";

export default function RPSChart() {
  return <BasicChart url="/operation/get-rps-report" chartType="line" />;
}
